"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DifferentialPairSchema = void 0;
const zod_1 = require("zod");
const NumericalBoundary_1 = require("../../NumericalBoundary");
exports.DifferentialPairSchema = zod_1.z.object({
    pairName: zod_1.z.string(),
    positiveId: zod_1.z.union([zod_1.z.string(), zod_1.z.number()]),
    negativeId: zod_1.z.union([zod_1.z.string(), zod_1.z.number()]),
    differentialVoltageSwing: zod_1.z
        .union([NumericalBoundary_1.NumericalBoundaryMinimumSchema, NumericalBoundary_1.NumericalBoundaryMaximumSchema, NumericalBoundary_1.NumericalBoundaryRangeSchema])
        .optional(),
});
//# sourceMappingURL=DifferentialPair.js.map